import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import Recovery from '../views/Recovery.vue';
import Hmac from '../views/Hmac.vue';
// import DevRegister from '../views/DevRegister.vue';
// import DevRecovery from '../views/DevRecovery.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/hmac',
    name: 'Hmac',
    component: Hmac,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/create',
    name: 'Create',
    component: Login,
  },
  {
    path: '/edit',
    name: 'Reset',
    component: Login,
  },
  // {
  //   path: '/dev-register',
  //   name: 'DevRegister',
  //   component: DevRegister,
  // },
  // {
  //   path: '/dev-recovery',
  //   name: 'DevRecovery',
  //   component: DevRecovery,
  // },
  {
    path: '/recovery',
    name: 'Recovery',
    component: Recovery,
  },
  {
    path: '/error',
    name: 'Error',
    props: true,
    component() {
      return import('../views/Error.vue');
    },
  },
];

const router = new VueRouter({
  // mode: 'history',
  routes,
});

export default router;
